export default __webpack_public_path__ + "static/logo-white-2e5c510aa01a8699a294d064b72379dd.svg";